/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * This class is used to model locations within the WGS84(SRID 4326) reference coordinate system.
 * @export
 * @interface PointDto
 */
export interface PointDto {
    /**
     * 
     * @type {number}
     * @memberof PointDto
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof PointDto
     */
    latitude: number;
}

export function PointDtoFromJSON(json: any): PointDto {
    return PointDtoFromJSONTyped(json, false);
}

export function PointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PointDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'longitude': json['longitude'],
        'latitude': json['latitude'],
    };
}

export function PointDtoToJSON(value?: PointDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'longitude': value.longitude,
        'latitude': value.latitude,
    };
}


